export default __webpack_public_path__ + "static/media/K.1ccacc4c.wav";